/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskQueuesManageViewType from '@jira/spa-apps__servicedesk-queues-manage-view/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskQueuesManageView: LazyComponent<
	({ hideHeaderForEmbed }: { hideHeaderForEmbed?: boolean }) => React.JSX.Element
> = lazyForPaint<typeof ServicedeskQueuesManageViewType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-queues-manage-page", jiraSpaEntry: "async-servicedesk-queues-manage-page" */ '@jira/spa-apps__servicedesk-queues-manage-view/src/index.tsx'
		),
	),
);

const AsyncServicedeskQueuesManageView = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskQueuesManageView}
		pageId="spa-apps/servicedesk/queues/manage"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskQueuesManageView;
